import React from 'react';
import styles from '../IntegrationCard.module.scss';

const IntegrationImage = ({ icon }) => {
    return <>{icon ? <img src={icon} alt="" /> : <span className={styles.integrationImgEmpty}></span>}</>;
};

export default IntegrationImage;
